import React from 'react'

import useResponsive from '../hooks/useResponsive'

export default (props) => {

  const { isFullhd, isMobileText } = useResponsive()

  return (
    <div className={ "tile is-parent" + (isFullhd ? " is-5" : " is-4") }>
      <ul
        className={ "tile is-child career__places"
        + (isFullhd || isMobileText ? " is-size-4" : " is-size-5")}>
        { props.data.map(thisPlace =>
            // Places
            <li
              key={thisPlace.key}
              className={props.currentPlace.key === thisPlace.key
                ? `career__placeItem career__placeItem-selected`
                : `career__placeItem`
              }>
              <button
                className="career__placeButton is-link-button"
                onClick={() => props.onSwitchPlace(thisPlace)}
                dangerouslySetInnerHTML={{__html:thisPlace.title}}>
              </button>
              <div className="career__placeVisualCue"></div>
            </li>
          )
        }
      </ul>
    </div>
  )
}